/**
 * Labstep
 *
 * @module grid/SmartTableProtocolValue/components/ColumnHeader
 * @desc Protocol Condition DataGrid Header
 */

import { GridSmartTableColumnHeaderBulkCreateResourceItemTrigger } from 'labstep-web/grid/SmartTableProtocolValue/components/ColumnHeader/BulkCreateResourceItemTrigger';
import { GridNewIndexColumnHeaderContextMenu as GridSmartTableColumnHeaderContextMenu } from 'labstep-web/grid/SmartTableProtocolValue/components/ColumnHeader/ContextMenu';
import { GridSmartTableColumnHeaderTrigger } from 'labstep-web/grid/SmartTableProtocolValue/components/ColumnHeader/Trigger';
import { Experiment } from 'labstep-web/models/experiment.model';
import type React from 'react';
import type { GridSmartTableColumnHeaderProps } from './types';

export const GridSmartTableColumnHeader: React.FC<
  GridSmartTableColumnHeaderProps
> = ({
  sort,
  filter,
  experimentOrProtocol,
  bulkCreateResourceItemEnabled = false,
  ...rest
}) => {
  const { column, displayName, icon, cornerIcon, action, ...params } =
    rest;

  const trigger =
    experimentOrProtocol instanceof Experiment &&
    bulkCreateResourceItemEnabled ? (
      <GridSmartTableColumnHeaderBulkCreateResourceItemTrigger
        {...rest}
      />
    ) : (
      <GridSmartTableColumnHeaderTrigger
        experimentOrProtocol={experimentOrProtocol}
        {...rest}
      />
    );
  return (
    <GridSmartTableColumnHeaderContextMenu
      trigger={trigger}
      sort={sort}
      filter={filter}
      {...params}
      {...rest}
      experimentOrProtocol={experimentOrProtocol}
    />
  );
};
